const productStoryModalProcessing = () => {
  const body = document.querySelector('body')
  const modalOpenButton = document.querySelectorAll('.modal-open-button')
  const modalCloseButton = document.querySelectorAll('.modal-close-button')
  const modal = document.querySelectorAll('.product-story-modal__body')
  /*
   * 旅日記モーダルの開閉処理
   */
  modalOpenButton.forEach((button) => {
    button.addEventListener('click', () => {
      const blogIdNum = button.dataset.blogId
      modal.forEach((modal) => {
        const modalIdNum = modal.dataset.modalId
        if (blogIdNum === modalIdNum) {
          modal.style.display = 'block'
        } else {
          modal.style.display = 'none'
        }
      })
      body.classList.add('is-view-story-modal')
    })
  })

  modalCloseButton.forEach((button) => {
    button.addEventListener('click', () => {
      body.classList.remove('is-view-story-modal')
    })
  })
}

export { productStoryModalProcessing }
